import { cn } from '@/lib/utils'

interface FormErrorProps {
	id?: string
	message?: string
	className?: string
	'data-testid'?: string
}

export function ErrorMessage({ id, message, className, 'data-testid': dataTestId }: FormErrorProps) {
	if (!message) {
		return null
	}

	return (
		<p id={id} data-testid={dataTestId} className={cn('mt-1 text-body text-destructive', className)}>
			{message}
		</p>
	)
}
